React = require 'react'
Auth = require 'db/auth'
Controller = require 'controller'
t = require('views/internal/recup-with-helpers')()
trackUe = require 'debug/trackUe'

BoardShortNames = {
  'education': 'Student Research Board'
  'project-management': 'Project Manager Board'
  'wedding': 'Wedding Planning Board'
  'business': 'Company Overview Board'
  'creative-arts': 'Podcast Editorial Workflow Board'
  'engineering-it': 'Production Workflow Board'
  'event-planning': 'Event Planning Board'
  'home': 'Chores Board'
  'marketing': 'Marketing Overview Board'
  'personal-goals': 'Life Goals Board'
  'productivity': 'Ultimate To-Do Board'
  'sales-crm': 'Sales & CRM Pipeline Board'
  'support': 'Bug Tracking Board'
  'travel': 'Vacation Board'
  'other': 'Bucket List'
}

module.exports = class InspirationScratchGuide extends React.Component
  displayName: 'InspirationScratchGuide'

  onReturn: =>
    # Returns user to their previous board
    trackUe('board', 'click', 'inspiration popover guide', '', '', 'by clicking the go back link in popover')
    Controller.displayBoard({
      idBoard: @props.previousBoardId
    }).done()

  render: t.renderable ->
    t.div '.inspiration-scratch-guide', =>
      t.div '.inspiration-scratch-guide-close', =>
        t.a { onClick: @props.onClose, href: '#' }, ->
          t.span '.icon-lg.icon-close'
      t.h6 ->
        t.text 'Add Your First List'
      t.p ->
        t.text 'You have a clean slate! Add lists to create a workflow or categories, and then add cards to your lists to represent tasks or ideas.'
      t.div '.inspiration-scratch-guide-go-back', =>
        t.a { onClick: @onReturn, href: '#' }, =>
          t.text 'Go back to '
          t.text BoardShortNames[@props.boardOptionValue]



// WEBPACK FOOTER //
// ./app/scripts/views/board/inspiration-scratch-guide-component.coffee